module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header header--main container-fluid flex-nowrap flex--justify-space-between"
  }, [_c('div', {
    staticClass: "header__item flex flex--align-vertical"
  }, [_c('div', {
    staticClass: "header__logo mr10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.linkToMainPage
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo/logo-icon-v2.svg",
      "alt": "Koncepted Platform"
    }
  })])], 1), _vm._v(" "), _c('nav', {
    class: [{
      closed: !_vm.open
    }, {
      open: _vm.open
    }, {
      closing: !_vm.open
    }],
    attrs: {
      "role": "navigation"
    }
  }, [_c('ul', {
    staticClass: "flex mb0 ml10 ml0-sm-down pl0"
  }, [(_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'schedule'
      },
      "tag": "li"
    }
  }, [_vm._v("Schedule")]) : _vm._e(), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'tasks'
      },
      "tag": "li"
    }
  }, [_vm._v("Tasks")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'projects'
      },
      "tag": "li"
    }
  }, [_vm._v("Projects")]), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'designer'])) ? _c('router-link', {
    staticClass: "relative",
    attrs: {
      "to": {
        name: 'messages'
      },
      "tag": "li"
    }
  }, [_vm._v("Messages  \n            "), (_vm.messagesCount !== 0) ? _c('span', {
    staticClass: "badge badge--messages text-space-05 text-uppercase ml2 mb0"
  }, [_vm._v("\n              " + _vm._s(_vm.messagesCount) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.checkUserRole(_vm.user.role, ['admin', 'projectManager'])) ? _c('li', {
    staticClass: "flex flex--align-vertical flex--justify-center"
  }, [_c('dropdown', {
    staticClass: "dropdown--header-links",
    attrs: {
      "selectable": false,
      "buttonText": 'Users',
      "buttonIconName": 'text-size-15 icon-chevron-down'
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'users'
            },
            "tag": "li"
          }
        }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'designers'
            },
            "tag": "li"
          }
        }, [_vm._v("Designers")])]
      }
    }], null, false, 3419029881)
  })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      },
      "tag": "li"
    }
  }, [_vm._v("Settings")]), _vm._v(" "), ((_vm.$route.name === 'tasks' || _vm.$route.name === 'projects') && _vm.checkUserRole(_vm.user.role, ['admin', 'projectManager', 'customer'])) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['project-create-modal', {
          userRole: _vm.user.role,
          userEmail: _vm.user.email
        }])
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus ml0 mr5"
  }), _vm._v("\n            New Project\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header__item header__item--middle flex-nowrap flex--align-vertical flex-nowrap mr20-xs-down mr30-sm-down"
  }, [(_vm.$route.name === 'users') ? _c('a', {
    staticClass: "link link--gray text-size-12 hidden-sm-down text-medium text-uppercase text-spase-2 mr20",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['add-user-modal'])
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus ml0 mr5"
  }), _vm._v("\n        Add User\n      ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "link link--gray text-size-12 text-medium text-uppercase text-spase-2 mr20",
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('div', {
    staticClass: "header__user flex flex--row flex--align-vertical"
  }, [_c('router-link', {
    staticClass: "flex flex--align-vertical\n          flex-nowrap",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [(_vm.user.avatarKey) ? _c('img', {
    staticClass: "img-circle img-circle--24 mr10",
    attrs: {
      "src": '/serve/s/' + _vm.user.avatarKey + '?w=48&h=48',
      "alt": "User Avatar"
    }
  }) : _c('img', {
    staticClass: "img-circle img-circle--24 mr10",
    attrs: {
      "src": "/static/images/user/user-avatar-demo@2x.png",
      "alt": "User Avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-ellipsis-wrap"
  }, [_c('p', {
    staticClass: "header__user--username text-ellipsis-block"
  }, [_vm._v(_vm._s(_vm.user.name) + " " + _vm._s(_vm.user.surname))]), _vm._v(" "), (_vm.isWorkLogDataLoading) ? _c('i', {
    staticClass: "icon--rectangle icon--rectangle-tall icon--rectange-dark-gray"
  }) : (_vm.workLogData) ? _c('tooltip', [_c('template', {
    slot: "reference"
  }, [_c('h6', {
    staticClass: "header__user--hours w-100 cursor-pointer text-ellipsis-block"
  }, [_vm._v(_vm._s(_vm._f("shortMonth")(_vm.currentPeriodStartDate)) + " " + _vm._s(_vm.currentPeriodAmount) + "h")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "header__user-worklog header__worklog-dropdown"
  }, _vm._l((_vm.workLogData), function(item) {
    return _c('li', {
      key: item.fromTs,
      class: {
        'pointer-events-none': item.amount === 0
      }
    }, [_c('details', {
      staticClass: "w-100"
    }, [_c('summary', {
      class: ['w-100', 'header__worklog-summary', {
        'header__worklog-summary-disabled': item.amount === 0
      }]
    }, [_c('div', {
      class: ['header__worklog-item', {
        'header__worklog-item-no-hours': _vm.amountSum === 0
      }]
    }, [_vm._v(_vm._s(_vm._f("shortDate")(item.fromTs)) + " - " + _vm._s(_vm._f("shortDate")(item.toTs))), _c('span', {
      staticClass: "text-color-white mlauto"
    }, [_vm._v(_vm._s(item.amount))])])]), _vm._v(" "), _vm._l((item.perProject), function(amount, projectName) {
      return _c('div', {
        key: projectName,
        staticClass: "header__worklog-project-item"
      }, [_vm._v("\n                            " + _vm._s(projectName) + " "), _c('span', {
        staticClass: "text-color-white mlauto"
      }, [_vm._v(_vm._s(amount))])])
    })], 2)])
  }), 0)])], 2) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header__item flex-nowrap flex--align-vertical visible-sm-down-flex"
  }, [(_vm.$route.name === 'users') ? _c('button', {
    staticClass: "btn-simple flex-none visible-sm-down-block",
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalShow', ['add-user-modal'])
      }
    }
  }, [_vm._v("Add User\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "header__menu-btn",
    class: {
      open: _vm.open
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e817822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 436
// module chunks = 2